import { IFeedbackData } from "../../repository/IFeedbackData";

export const createFeedback = (payload: IFeedbackData) => ({
  type: "@saga/CREATE_FEEDBACK",
  payload,
});
